import F from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
import * as G from "react";
import C from "../../../rc-util/es/raf.mjs";
function L(e, i, I, M, d, R, t, S) {
  var b = G.useRef();
  return function(r) {
    if (r == null) {
      S();
      return;
    }
    if (C.cancel(b.current), typeof r == "number")
      t(r);
    else if (r && F(r) === "object") {
      var f, m = r.align;
      "index" in r ? f = r.index : f = i.findIndex(function(c) {
        return d(c) === r.key;
      });
      var h = r.offset, w = h === void 0 ? 0 : h, q = function c(k, p) {
        if (!(k < 0 || !e.current)) {
          var o = e.current.clientHeight, y = !1, s = p;
          if (o) {
            for (var z = p || m, j = 0, u = 0, l = 0, A = Math.min(i.length, f), v = 0; v <= A; v += 1) {
              var D = d(i[v]);
              u = j;
              var a = I.get(D);
              l = u + (a === void 0 ? M : a), j = l, v === f && a === void 0 && (y = !0);
            }
            var n = null;
            switch (z) {
              case "top":
                n = u - w;
                break;
              case "bottom":
                n = l - o + w;
                break;
              default: {
                var x = e.current.scrollTop, E = x + o;
                u < x ? s = "top" : l > E && (s = "bottom");
              }
            }
            n !== null && n !== e.current.scrollTop && t(n);
          }
          b.current = C(function() {
            y && R(), c(k - 1, s);
          }, 2);
        }
      };
      q(3);
    }
  };
}
export {
  L as default
};
//# sourceMappingURL=useScrollTo.mjs.map
